import { render, staticRenderFns } from "./Vrate.vue?vue&type=template&id=23dee188"
import script from "./Vrate.vue?vue&type=script&lang=js"
export * from "./Vrate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports